import {useState} from 'react';

export function useToggle(initialState = false) {
  const [toggle, setToggle] = useState(initialState);
  return {
    isToggled: toggle,
    toggle: (value?: boolean) => setToggle((prev) => (typeof value === 'boolean' ? value : !prev)),
  };
}
